import { LAYOUTS, } from '@voltmoney/types';
import { BorderRadiusTokens, ButtonTypeTokens, ButtonWidthTypeToken, ColorTokens, FontFamilyTokens, FontSizeTokens, IconSizeTokens, IconTokens, SizeTypeTokens, StackAlignItems, StackJustifyContent, StackType, StackWidth, TextAlignTokens, WIDGET, } from '@voltmoney/schema';
import { ROUTE } from '../../../routes';
import { ACTION } from './types';
import { confirm } from './actions';
import { heightMap } from '../../../configs/height';
import SharedPropsService from "../../../SharedPropsService";
export const template = () => {
    return {
        layout: {
            id: ROUTE.JOINT_HOLDER_NOTIFY,
            type: LAYOUTS.MODAL,
            style: {
                height: heightMap[ROUTE.JOINT_HOLDER_NOTIFY],
            },
            widgets: [{ id: 'stack_root', type: WIDGET.STACK }],
        },
        datastore: {
            stack_root: {
                justifyContent: StackJustifyContent.center,
                alignItems: StackAlignItems.center,
                widgetItems: [
                    { id: 'space0', type: WIDGET.SPACE },
                    { id: 'icon', type: WIDGET.ICON },
                    { id: 'space1', type: WIDGET.SPACE },
                    { id: 'title', type: WIDGET.TEXT },
                    { id: 'title_space', type: WIDGET.SPACE },
                    { id: 'descriptionStack', type: WIDGET.STACK },
                    { id: 'description_space', type: WIDGET.SPACE },
                    { id: 'confirm', type: WIDGET.BUTTON },
                    { id: 'spaceBottom', type: WIDGET.SPACE },
                ],
            },
            space0: { size: SizeTypeTokens.MD },
            icon: {
                name: IconTokens.Warning,
                size: IconSizeTokens.XXXXL,
            },
            space1: { size: SizeTypeTokens.XL },
            title: {
                label: `Joint holders found for the selected assets`,
                fontSize: FontSizeTokens.XL,
                color: ColorTokens.Grey_Night,
                fontFamily: FontFamilyTokens.Poppins,
                fontWeight: '600',
                textAlign: TextAlignTokens.center,
                lineHeight: 28,
            },
            title_space: { size: SizeTypeTokens.XL },
            description_space: { size: SizeTypeTokens.XXL },
            descriptionStack: {
                type: StackType.column,
                width: StackWidth.CONTENT,
                widgetItems: [
                    { id: 'text1', type: WIDGET.TEXT },
                    { id: 'subStack1', type: WIDGET.STACK },
                    { id: 'subStack2', type: WIDGET.STACK },
                ],
                bgColor: ColorTokens.Warning_25,
                padding: {
                    left: SizeTypeTokens.XL,
                    right: SizeTypeTokens.XL,
                    top: SizeTypeTokens.MD,
                    bottom: SizeTypeTokens.MD,
                },
                borderConfig: {
                    borderRadius: BorderRadiusTokens.BR3,
                },
            },
            text1: {
                label: `Note:\n`,
                fontSize: FontSizeTokens.MD,
                color: ColorTokens.Grey_Night,
                fontFamily: FontFamilyTokens.Inter,
                fontWeight: '700',
                lineHeight: 24,
            },
            subStack1: {
                type: StackType.row,
                width: StackWidth.CONTENT,
                paddingLeft: 8,
                alignItems: StackAlignItems.center,
                widgetItems: [
                    { id: 'subStack1Icon1', type: WIDGET.ICON },
                    { id: 'subStack1Text2', type: WIDGET.TEXT },
                ],
            },
            subStack1Icon1: {
                name: IconTokens.Dot,
                size: IconSizeTokens.XXXL,
                color: ColorTokens.Grey_Night,
            },
            subStack1Text2: {
                label: `Digital KYC is required for joint holder(s)`,
                fontSize: FontSizeTokens.MD,
                paddingLeft: 4,
                color: ColorTokens.Grey_Night,
                fontFamily: FontFamilyTokens.Inter,
                fontWeight: '500',
                lineHeight: 24,
            },
            spaceXS: {
                size: SizeTypeTokens.SM
            },
            subStack2: {
                type: StackType.row,
                width: StackWidth.CONTENT,
                paddingLeft: 8,
                alignItems: StackAlignItems.flexStart,
                widgetItems: [
                    { id: 'subStack2IconStack', type: WIDGET.STACK },
                    { id: 'subStack2Text2', type: WIDGET.TEXT },
                ],
            },
            subStack2IconStack: {
                type: StackType.column,
                widgetItems: [
                    {
                        id: "spaceXS", type: WIDGET.SPACE
                    },
                    {
                        id: "subStack1Icon1", type: WIDGET.ICON
                    }
                ]
            },
            subStack2Text2: {
                paddingLeft: 8,
                label: `Our team will contact you for signature on addendum document & co-applicant form`,
                fontSize: FontSizeTokens.MD,
                color: ColorTokens.Grey_Night,
                fontFamily: FontFamilyTokens.Inter,
                fontWeight: '500',
                lineHeight: 24,
            },
            confirm: {
                id: 'bt_confirmPledge_confirm',
                label: `Confirm & Proceed`,
                fontSize: FontSizeTokens.MD,
                type: ButtonTypeTokens.LargeFilled,
                width: ButtonWidthTypeToken.FULL,
                action: {
                    type: ACTION.CONFIRM,
                    payload: {},
                    routeId: ROUTE.JOINT_HOLDER_NOTIFY,
                },
            },
            spaceBottom: { size: SizeTypeTokens.LG },
        },
    };
};
export const jointHolderNotifyMf = {
    onLoad: async (_, {}) => {
        await SharedPropsService.setIsJointHolderOpened(true);
        return Promise.resolve(template());
    },
    actions: {
        [ACTION.CONFIRM]: confirm,
    },
};
